module.exports = __webpack_public_path__ + "img/sol.c3ec52c1.svg";